import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  UntypedFormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import * as _ from 'lodash';
import { take } from 'rxjs';

@Component({
    selector: 'pr-input-country',
    templateUrl: './pr-input-country.component.html',
    styleUrls: ['./pr-input-country.component.scss'],
    standalone: false
})
export class PrInputCountryComponent implements ControlValueAccessor, OnInit {
  @Input() formGroup: string;
  @Input() formControlName: string = 'country';
  @Input() loading: boolean = true;
  @Input() label: string = 'Pays';
  @Input() optionLabel: string;
  @Input() derrors: boolean = false;
  @Input() highlightOnValue: boolean = false;
  @Input() optionIcon: (string) => string[];
  @Input() options: any[];
  countries = [];
  value: any;
  _ = _;
  touched = false;
  disabled = false;
  onChange = val => {};
  onTouched = () => {};

  get control(): UntypedFormControl {
    return this.controlContainer.control.get(
      this.formControlName,
    ) as UntypedFormControl;
  }

  constructor(
    private controlContainer: ControlContainer,
    private referenceDao: ReferenceDao,
  ) {}

  ngOnInit(): void {
    this.referenceDao
      .getCountries()
      .pipe(take(1))
      .subscribe(countries => {
        this.countries = countries;
        this.loading = false;
      });
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  getIcon(option) {
    const icons = [`fs-${option.id.toLowerCase()}`];
    return icons;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.countries.includes(this.control.value))
      return { wrong: { value: true } };
    return null;
  }
}
